import { Menu } from 'lucide';

//MUI
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

//common
import Icon from 'common/components/Icon';
import MyLink from 'common/components/MyLink';
import { setOpenAsideBarMobile } from '@redux/cacheReducer';
import { HEADER_PORTAL_ID, HEADER_TOOLBAR_PORTAL_ID } from 'layout/main/constants';
import useGeneralHook from 'common/hook/useGeneralHook';
import { getBrand } from 'config/brand';

//screen
import DefaultBreadcrumb from 'layout/main/DefaultBreadcrumb';
import ProfileBox from 'layout/main/ProfileBox';

const DefaultHeader = () => {
  const { dispatch, isMobile } = useGeneralHook();
  const brandName = getBrand().app_name || 'GANET';

  const pageHeading = (
    <Box className="flex items-center flex-1 min-w-0" id={HEADER_PORTAL_ID}>
      <DefaultBreadcrumb />
    </Box>
  );

  return (
    <>
      <Box
        className="flex items-center gap-2 z-10"
        sx={{
          bgcolor: 'transparent',
          borderBottom: 1,
          borderColor: 'divider',
          py: 1.25,
          pl: isMobile ? 1 : 2.5,
          pr: isMobile ? 1 : 2.5,
        }}
      >
        {isMobile ? (
          <>
            <IconButton
              aria-label="Mở menu"
              sx={{
                flexShrink: 0,
                bgcolor: 'background.paper',
                border: 1,
                borderColor: 'divider',
                borderRadius: '10px',
              }}
              onClick={() => {
                dispatch(setOpenAsideBarMobile());
              }}
            >
              <Icon icon={Menu} />
            </IconButton>
            <MyLink to="/" aria-label="Link to HomePage">
              <Typography
                sx={{
                  color: 'text.primary',
                  fontWeight: 800,
                  fontSize: 18,
                  letterSpacing: '0.08em',
                  lineHeight: 1.3,
                }}
              >
                {brandName}
              </Typography>
            </MyLink>
            {pageHeading}
          </>
        ) : (
          pageHeading
        )}
        {!isMobile && <ProfileBox />}
      </Box>
      {isMobile && <Box id={HEADER_TOOLBAR_PORTAL_ID} />}
    </>
  );
};

export default DefaultHeader;
